/**
 * Navigation badge counts hook.
 * Aggregates counts for sidebar nav items in one place so Layout
 * has a single call instead of scattered query hooks.
 * @packageDocumentation
 */

import { useDlqTotalCount } from './useDlq.js';
import { useMappings } from './useMappings.js';

/**
 * Returns badge counts for the main navigation items.
 *
 * @returns { object } An object with optional numeric counts for each nav item.
 */
export const useNavBadges = () => {
  const { data: mappingsData } = useMappings();
  const dlqTotal = useDlqTotalCount();

  return {
    dlq: dlqTotal,
    mappings: mappingsData?.total,
  };
};
